jQuery(document).ready(function ($) {

    var lang = $('html').attr('lang');
    var show = 'Show';
    var hide = 'Hide';
    var showAll = 'Show all';
    var hideAll = 'Hide all';

    if (lang === 'fr-FR') {
        show = 'Afficher';
        hide = 'Cacher';
        showAll = 'Afficher tous';
        hideAll = 'Cacher tout';
    }



    var toggleAllButton = $('#bocss-profile__toggleAll');

    var toggleButtonHTML = toggleAllButton.clone();

    let $toggleButton = $(toggleButtonHTML).insertAfter('.bocss-profile__toggleable h2, .toggleDiv h2.bocss-profile__toggleable');
    $toggleButton.html(show);
    $toggleButton.addClass('bocss-profile__toggleButton');
    $toggleButton.removeAttr('id');


    toggleAllButton.click(function () {
        if (toggleAllButton.html() === hideAll) {

            $('.bocss-profile__publication').slideUp();
            $('.bocss-profile__toggleable .results').slideUp();
            $('.bocss-profile__other-results').slideUp();

            toggleAllButton.html(showAll);

            $toggleButton.each(function () {
                $(this).html(show);
            });


        } else {
            $('.bocss-profile__publication').slideDown();
            $('.bocss-profile__toggleable .results').slideDown();
            $('.bocss-profile__other-results').slideDown();

            toggleAllButton.html(hideAll);
            $toggleButton.each(function () {
                $(this).html(hide);
            });
        }

    });

    $('.toggleDiv').each(function () {
        var toggleHeader = $(this).find('h2').attr('id');
        $('#' + toggleHeader).click(function () {
            checkToggle($(this).next('.bocss-profile__toggleButton'));
            $('.bocss-profile__' + toggleHeader).slideToggle();
        });
    });

    $('.bocss-profile__toggleButton').click(function () {
        checkToggle($(this));
        $(this).next('div').slideToggle();
        updateToggleAllButtonState();
    });

    $('.bocss-profile__toggleable h2').click(function () {
        checkToggle($(this).next('.bocss-profile__toggleButton'));

        $(this).parent().find('.results').slideToggle();
        updateToggleAllButtonState();
    });

    function checkToggle(element) {
        var button = $(element);
        if (button.html() === show) {
            button.html(hide);
        } else {
            button.html(show);
        }
    }

    function updateToggleAllButtonState() {
        var allShow = $('.bocss-profile__toggleButton:contains("'+ hide +'")').length === 0;
        var allHide = $('.bocss-profile__toggleButton:contains("'+ show +'")').length === 0;
        if (allShow && !allHide) {
            toggleAllButton.html(showAll);
        } else if (!allShow && allHide) {
            toggleAllButton.html(hideAll);
        }
    }


    // Check if the sticky code is supported
    var positionStickySupport = function () {
        var el = document.createElement('a'),
            mStyle = el.style;
        mStyle.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
        return mStyle.position.indexOf('sticky') !== -1;
    }();

    // The mobile breakpoint.
    var MOBILE_WIDTH = 991;

    /**
     * If the window has hit the mobile breakpoint.
     * @returns {boolean} true if mobile
     */
    function isMobile() {
        return window.innerWidth <= MOBILE_WIDTH;
    }

    var profile = $('#bocss-profile');

    if (profile.length > 0 && !(positionStickySupport)) {
        $(document).scroll(function () {
            checkOffset();
        });

        $(window).resize(function () {
            checkOffset();
            $('.bocss-profile__card').css('width', profile.width());
        });

        checkOffset();
    } else {
        // set the height of menu + 5 for sticky
        var stickyTop = $('.navbar').height() + 5;
        profile.css('top', stickyTop);
    }

    function checkOffset() {
        var footNav = $('#foot-nav');
        var a = $(document).scrollTop() + window.innerHeight;
        var b = footNav.offset().top;

        var profileCard = $('.bocss-profile__card');

        if (isMobile() || !isLong()) {
            profile.css('position', '');
            profileCard.css('position', '');
            profile.css('bottom', '');
            profileCard.css('top', '');
            return false;
        }

        if ($(document).scrollTop() + window.innerHeight >= footNav.offset().top && $(document).scrollTop() >= 115) {
            profile.css('bottom', ((a - b) + 45) + 'px');
            profileCard.css('top', -((a - b) - 45) + 'px');
        }

        if ($(document).scrollTop() <= 115) {
            profile.css('position', '');
            profileCard.css('position', '');
            profileCard.css('top', '');
            profile.css('bottom', '');
        }

        if ($(document).scrollTop() + window.innerHeight <= footNav.offset().top && $(document).scrollTop() >= 115) {
            profile.css('position', 'relative');
            profileCard.css('position', 'fixed');
            profileCard.css('width', profile.width());
            profile.css('bottom', '0');
            profileCard.css('top', '55px');

        }
    }

    function isLong() {
        return window.outerHeight < $('#main-content').outerHeight();
    }
});
